import React, { useEffect, useRef } from "react";

const UNDEFINED_LANG_MAP = {
  as: "Assamese",
  or: "Odia",
  "mni-Mtei": "Manipuri",
  mni: "Manipuri",
};

const patchUndefinedLabels = () => {
  const allLinks = document.querySelectorAll("a[data-gt-lang]");

  allLinks.forEach((link) => {
    const langCode = link.getAttribute("data-gt-lang");
    if (!langCode || !UNDEFINED_LANG_MAP[langCode]) return;

    const friendlyName = UNDEFINED_LANG_MAP[langCode];

    // Fix text nodes that say "undefined" without touching ones already correct
    link.childNodes.forEach((node) => {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() === "undefined"
      ) {
        node.textContent = ` ${friendlyName}`;
      }
    });

    link.querySelectorAll("*").forEach((el) => {
      if (el.tagName === "IMG") return; // Skip the img itself
      if (
        el.childNodes.length === 1 &&
        el.firstChild.nodeType === Node.TEXT_NODE &&
        el.firstChild.textContent.trim() === "undefined"
      ) {
        el.firstChild.textContent = friendlyName;
      }
    });

    // Replace broken flag image with India flag and set alt to empty string so browser doesn't render alt text alongside our fixed img
    const imgs = link.querySelectorAll("img");
    imgs.forEach((img) => {
      img.src = "https://cdn.gtranslate.net/flags/svg/gu.svg";
      img.alt = ""; 
      img.style.width = "22px";
      img.style.height = "auto";
      img.style.marginTop = "4px";
    });
  });
};

const GTranslateWidget = () => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const wrapperSelector = ".gtranslate_wrapper";

    if (!window.gtranslateSettings) {
      window.gtranslateSettings = {
        default_language: "en",
        native_language_names: false,
        detect_browser_language: true,
        languages: [
          "en", "fr", "de", "it", "es", "ar", "hi", "nl", "ja", "ru",
          "th", "bg", "zh-TW", "ko", "id", "pt", "tr", "af", "ms","si","bn",
          "as", "gu", "kn", "ml", "mr", "or", "pa", "ta", "te", 
          "mni-Mtei",
        ],
        wrapper_selector: wrapperSelector,
        flag_size: 20,
        switcher_horizontal_position: "right",
        switcher_vertical_position: "inline",
        alt_flags: {
          en: "usa",
          as: "in",
          or: "in",
          "mni-Mtei": "in",
          mni: "in",
        },
      };

      const popupScript = document.createElement("script");
      popupScript.src = "https://cdn.gtranslate.net/widgets/latest/popup.js";
      popupScript.defer = true;

      popupScript.addEventListener("load", () => {
        setTimeout(patchUndefinedLabels, 800);
        setTimeout(patchUndefinedLabels, 2000);
      });

      document.body.appendChild(popupScript);
    } else {
      window.GTranslateWidget?.translate(wrapperSelector);
      setTimeout(patchUndefinedLabels, 800);
      setTimeout(patchUndefinedLabels, 2000);
    }

    const observer = new MutationObserver(() => {
      const popup = document.querySelector("a[data-gt-lang='as'], a[data-gt-lang='or'], a[data-gt-lang='mni-Mtei']");
      if (popup) {
        patchUndefinedLabels();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const style = document.createElement("style");
    style.textContent = `
      .goog-te-combo {
        width: 120px;
      }
      .gtranslate_wrapper img {
        width: 22px !important;
        height: auto !important;
        margin-top: 4px !important;
      }
    .translated-ltr button,
    .translated-rtl button {
        white-space: normal !important;
        height: auto !important;
        min-height: 32px !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
        line-height: 1.4 !important;
    }
    .ant-select-selector {
        height: auto !important;
        min-height: 32px !important;
    }
    .ant-select-selection-placeholder,
    .ant-select-selection-item {
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: unset !important;
        line-height: 1.4 !important;
        padding-top: 4px !important;
        padding-bottom: 4px !important;
    }
    .ant-select {
        height: auto !important;
    }

    .ant-select-item-option-content {
        white-space: normal !important;
        word-break: break-word !important;
    }

  @media (max-width: 425px) {
    .gt_black_overlay {
    position: fixed !important;
    top: 0 !important;
    left: calc(-85vw + 100%) !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 19881204 !important;
  }
    .gt_white_content {
      top: 100% !important;
      bottom: 0 !important;
      left: calc(-85vw + 100%) !important;;
      right: 0 !important;
      transform: none !important;
      margin: 0 !important;
      width: 100vw !important;
      max-width: 100vw !important;
      max-height: 60vh !important;
      border-radius: 12px 12px 0 0 !important;
      box-shadow: 0 -4px 12px rgba(0,0,0,0.2) !important;
    }
  }
  @media (max-width: 370px) {
    .gt_black_overlay {
      position: fixed !important;
      top: 0 !important;
      left: calc(-95vw + 100%) !important;
      width: 120vw !important;
      height: 100vh !important;
      z-index: 19881204 !important;
    }
    .gt_white_content {
      top: 100% !important;
      bottom: 0 !important;
      left: calc(-95vw + 100%) !important;
      right: 0 !important;
      transform: none !important;
      margin: 0 !important;
      width: 120vw !important;
      max-width: 120vw !important;
      max-height: 65vh !important;
      border-radius: 12px 12px 0 0 !important;
      box-shadow: 0 -4px 12px rgba(0,0,0,0.2) !important;
      overflow-y: auto !important;
  }

  .gt_languages {
    flex-wrap: wrap !important;
    overflow-y: auto !important;
    max-height: 55vh !important;
  }

  .gt_languages a.glink {
    width: 50% !important;
    box-sizing: border-box !important;
  }
  }
    `;
    document.head.appendChild(style);

    return () => {
      observer.disconnect();

      const widgetElement = document.querySelector(".gtranslate_widget");
      if (widgetElement) widgetElement.remove();

      const popupScript = document.querySelector(
        'script[src="https://cdn.gtranslate.net/widgets/latest/popup.js"]'
      );
      if (popupScript) popupScript.remove();

      style.remove();
    };
  }, []);

  return <div ref={wrapperRef} className="gtranslate_wrapper"></div>;
};

export default GTranslateWidget;